import { render, staticRenderFns } from "./AiVerdictInsights.vue?vue&type=template&id=77631858"
import script from "./AiVerdictInsights.vue?vue&type=script&lang=js"
export * from "./AiVerdictInsights.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports